export default __webpack_public_path__ + "static/media/ObjektivMk1_Trial_Lt.6d6dace5.ttf";